<div
  class="service-categories-banner"
  *ngIf="shouldDisplayBanner && appliedBudgetSupportTypes?.length && otherBudgetSupportTypesAvailable?.length"
>
  <mable-banner
    category="headed-banner"
    heading="New service categories"
    icon="information-circle"
    [canClose]="false"
  >
    <ng-container class="content">
      <div class="applied-service-categories">
        <p>The following service categories are now available for rates in your agreement:</p>
        <ul>
          <li
            *ngFor="let appliedBudgetSupportType of appliedBudgetSupportTypes"
            class="applied-budget-support-type-item"
          >
            {{ appliedBudgetSupportType.displayName }}
          </li>
        </ul>
      </div>

      <h3 class="title">Other available service categories</h3>
      <ul>
        <li *ngFor="let otherBudgetSupportTypeAvailable of otherBudgetSupportTypesAvailable">
          {{ otherBudgetSupportTypeAvailable.displayName }}
        </li>
      </ul>

      <app-request-budget-support-item
        [hasPadding]="false"
        [supportProviderUuid]="supportProviderUuid"
        [consumerUuid]="consumerUuid"
      >
      </app-request-budget-support-item>

      <div>
        <h3 class="title">What you need to do</h3>
        <ol>
          <li>
            Review the service categories applied to your rates and edit if you want to make changes, including
            selecting different service categories.
          </li>
          <li>
            Save and send the updated agreement to {{ clientFirstName }} to review and accept, and tell them so they
            know what to expect. Once they accept it, the changes will take effect.
          </li>
        </ol>
      </div>
    </ng-container>
  </mable-banner>
</div>
